export enum AppRouteNames {
  AccountChangeBankDetails = "account-change-bank-details",
  AccountChangeEmail = "account-change-email",
  AccountChangePassword = "account-change-password",
  AccountChangeProfile = "account-change-profile",
  AccountDeleteAccount = "account-delete-account",
  AccountDocuments = "account-documents",
  AccountNotFound = "account-not-found",
  AccountOverview = "account-overview",
  AccountSupportCasesOverview = "account-support-cases-overview",
  AdminControlCenterStart = "admin-control-center-start",
  AdminControlCenterNotFound = "admin-control-center-not-found",
  Dashboard = "dashboard",
  DashboardNotFound = "dashboard-not-found",
  DevLogin = "dev-login",
  FbsHubAddCustomer = "fbs-hub-add-customer",
  FbsHubCheckout = "fbs-hub-checkout",
  FbsHubGasContainers = "fbs-hub-gas-containers",
  FbsHubDocuments = "fbs-hub-documents",
  FbsHubMeterReport = "fbs-hub-meter-report",
  FbsHubAutogasMeterReport = "fbs-hub-autogas-meter-report",
  FbsHubMonthlyPayment = "fbs-hub-monthly-payment",
  FbsHubNotFound = "fbs-hub-not-found",
  FbsHubOrders = "fbs-hub-orders",
  FbsHubPriceCockpit = "fbs-hub-price-cockpit",
  FbsHubRegistration = "fbs-hub-registration",
  FbsHubStart = "fbs-hub-start",
  FbsHubWestfalengasBio = "fbs-hub-westfalengas-bio",
  FbsHubWestfalengasBioTariff = "fbs-hub-westfalengas-bio-tariff",
  FinishRegistration = "finish-registration",
  FinishRegistrationNotFound = "finish-registration-not-found",
  FleetAtHomeCharges = "fleet-at-home-charges",
  FleetAtHomeCredits = "fleet-at-home-credits",
  FleetAtHomeDashboard = "fleet-at-home-dashboard",
  FleetAtHomeManagementCharges = "fleet-at-home-management-charges",
  FleetAtHomeManagementDashboard = "fleet-at-home-management-dashboard",
  FleetAtHomeManagementNotFound = "fleet-at-home-management-not-found",
  FleetAtHomeManagementUsers = "fleet-at-home-management-users",
  FleetAtHomeManagementSettings = "fleet-at-home-management-settings",
  FleetAtHomeManagementTcoCalculator = "fleet-at-home-management-tco-calculator",
  FleetAtHomeNotFound = "fleet-at-home-not-found",
  FleetAtHomeShop = "fleet-at-home-shop",
  FleetAtHomeShopProduct = "fleet-at-home-shop-product",
  FleetAtHomeStations = "fleet-at-home-stations",
  GasShopAddCustomer = "gas-shop-add-customer",
  GasShopBottleInventory = "gas-shop-bottle-inventory",
  GasShopCheckout = "gas-shop-checkout",
  GasShopDeliveredOrders = "gas-shop-delivered-orders",
  GasShopDocuments = "gas-shop-documents",
  GasShopEmailAddresses = "gas-shop-email-addresses",
  GasShopFavorites = "gas-shop-favorites",
  GasShopGasMixtureConfigurator = "gas-shop-gas-mixture-configurator",
  GasShopNotFound = "gas-shop-not-found",
  GasShopOpenOrders = "gas-shop-open-orders",
  GasShopPalletConfigurator = "gas-shop-pallet-configurator",
  GasShopProductCatalogCategory = "gas-shop-product-catalog-category",
  GasShopProductCatalogProductDetails = "gas-shop-product-catalog-product-details",
  GasShopQuickOrder = "gas-shop-quick-order",
  GasShopQuotaManagement = "gas-shop-quota-management",
  GasShopReturnComplaints = "gas-shop-return-complaints",
  GasShopReturnEmpties = "gas-shop-return-empties",
  GasShopRGoodsAndSystemBottles = "gas-shop-r-goods-and-system-bottles",
  GasShopShippingAddresses = "gas-shop-shipping-addresses",
  GasShopShoppingCart = "gas-shop-shopping-cart",
  GasShopStart = "gas-shop-start",
  GeneralError = "general-error",
  Impersonate = "impersonate",
  InvitedUserRegistration = "invited-user-registration",
  Login = "login",
  Maintenance = "maintenance",
  MeterReport = "meter-report",
  MobilityUserRegistration = "mobility-registration",
  NewUserRegistration = "new-user-registration",
  NotFound = "not-found",
  RegistrationOverview = "registration-overview",
  ThgQuoteNotFound = "thg-quote-not-found",
  ThgQuoteOverview = "thg-quote-overview",
  ThgQuoteVehicleRegistration = "thg-quote-vehicle-registration",
  ThgQuoteUnauthenticatedVehicleRegistration = "thg-quote-registration",
  ThgQuoteVehicleApplications = "thg-quote-vehicle-applications",
  VerifyEmail = "verify-email",
  WccCardsArchive = "wcc-management-cards-archive",
  WccCardsOverview = "wcc-management-cards-overview",
  WccCharges = "wcc-management-charges",
  WccInvoices = "wcc-management-invoices",
  WccNotFound = "wcc-management-not-found",
  WccOrders = "wcc-management-orders",
  WestfalenIdAccountManagementOverview = "westfalen-id-account-management-overview",
  WestfalenIdAccountManagementUsers = "westfalen-id-account-management-users",
  WestfalenIdAccountManagementInvitations = "westfalen-id-account-management-invitations",
  WestfalenIdAccountManagementServices = "westfalen-id-account-management-services",
  WestfalenIdAccountManagementSettings = "westfalen-id-account-management-settings",
  WestfalenIdAccountManagementSupportCases = "westfalen-id-account-management-support-cases",
  WestfalenIdAccountNotFound = "westfalen-id-account-not-found",
  WscCardsOverview = "wsc-management-cards-overview",
  WscInvoices = "wsc-management-invoices",
  WscNotFound = "wsc-management-not-found",
  WscSettings = "wsc-management-settings",
  WscTransactions = "wsc-management-transactions",
}
